import JSEncrypt from 'jsencrypt'

export const encryptLoginData = (data) => {
    const publicKey = process.env.REACT_APP_LOGIN_PUBLIC_KEY
    if (!publicKey) {
        return data
    }

    const encryptor = new JSEncrypt()
    encryptor.setPublicKey(publicKey)

    // Encrypt password specifically, or other fields as needed
    // Assuming data is the formData object
    if (data.password) {
        const encryptedPassword = encryptor.encrypt(data.password)
        if (encryptedPassword) {
            data = { ...data, password: encryptedPassword }
        }
    }

    if (data.confirm_password) {
        const encryptedConfirmPassword = encryptor.encrypt(data.confirm_password)
        if (encryptedConfirmPassword) {
            data = { ...data, confirm_password: encryptedConfirmPassword }
        }
    }

    if (data.current_password) {
        const encryptedCurrent = encryptor.encrypt(data.current_password)
        if (encryptedCurrent) {
            data = { ...data, current_password: encryptedCurrent }
        }
    }

    if (data.new_password) {
        const encryptedNew = encryptor.encrypt(data.new_password)
        if (encryptedNew) {
            data = { ...data, new_password: encryptedNew }
        }
    }

    return data
}
